import React from 'react';
import { Spin } from 'antd';

const CHUNK_RELOAD_FLAG = 'route-chunk-reload-attempted';

class RouteErrorBoundary extends React.Component {
  state = { hasError: false };

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error) {
    const isChunkLoadError =
      error &&
      (error.name === 'ChunkLoadError' ||
        /Loading( CSS)? chunk .* failed/i.test(error.message || ''));

    if (isChunkLoadError && !window.sessionStorage.getItem(CHUNK_RELOAD_FLAG)) {
      window.sessionStorage.setItem(CHUNK_RELOAD_FLAG, '1');
      window.location.reload();
    }
  }

  render() {
    if (this.state.hasError) {
      return (
        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center',
            height: '100vh',
            textAlign: 'center',
            padding: 20,
          }}
        >
          <Spin size="large" style={{ marginBottom: 16 }} />
          <p>Não foi possível carregar esta página. Tente recarregar.</p>
          <button type="button" onClick={() => window.location.reload()}>
            Recarregar
          </button>
        </div>
      );
    }

    return this.props.children;
  }
}

export default RouteErrorBoundary;
